/**
 * Generates an inline SVG Data URI for movie/song poster artwork.
 * This guarantees 100% rendering without any 404s, format errors, or network calls.
 * 
 * @param {string} title - Song or Movie Title
 * @param {string} subtitle - Subtitle (e.g. Movie Name or Year)
 * @returns {string} SVG Data URI
 */
export function getDynamicPosterUrl(title = 'Lyricsverse', subtitle = 'Movie Soundtrack') {
  const displayTitle = String(title || 'Lyricsverse').trim();
  const displaySub = String(subtitle || 'Movie Soundtrack').trim();

  // Escape special XML characters
  const cleanTitle = displayTitle
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');

  const cleanSub = displaySub
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');

  // Pick gradient theme based on title length/character codes for visual variety
  const themes = [
    { bg1: '#1e1b4b', bg2: '#311042', accent: '#a855f7', textAccent: '#c084fc' }, // Violet/Purple
    { bg1: '#450a0a', bg2: '#18181b', accent: '#f97316', textAccent: '#fb923c' }, // Crimson/Orange
    { bg1: '#064e3b', bg2: '#0f172a', accent: '#10b981', textAccent: '#34d399' }, // Emerald/Teal
    { bg1: '#172554', bg2: '#0f172a', accent: '#3b82f6', textAccent: '#60a5fa' }, // Blue/Indigo
  ];

  let charSum = 0;
  for (let i = 0; i < displayTitle.length; i++) {
    charSum += displayTitle.charCodeAt(i);
  }
  const theme = themes[charSum % themes.length];

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 600" width="100%" height="100%"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="${theme.bg1}"/><stop offset="100%" stop-color="${theme.bg2}"/></linearGradient></defs><rect width="400" height="600" fill="url(#g)"/><circle cx="200" cy="220" r="100" fill="${theme.accent}" opacity="0.2"/><path d="M180 190 v60 l50 -30 z" fill="${theme.accent}"/><text x="200" y="420" font-family="system-ui, -apple-system, sans-serif" font-weight="900" font-size="24" fill="#ffffff" text-anchor="middle">${cleanTitle}</text><text x="200" y="460" font-family="system-ui, -apple-system, sans-serif" font-weight="700" font-size="15" fill="${theme.textAccent}" text-anchor="middle" letter-spacing="2">${cleanSub}</text></svg>`;

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
